export default __webpack_public_path__ + "static/butik_img5-3367d690e2d8c51752212485ae8eb2be.png";